import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const InstructionBar = ({ ...overrides }) => {
  const instructionBarConfig = {
    instructions: [],
    elevation: 0,
    variant: 'light',
    ...overrides
  }

  const KeyWrapper = withStyles((theme) => ({
    root: {
      display: 'inline',
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 4,
      paddingBottom: 4,
      marginRight: theme.spacing(0.5),
      color:
        instructionBarConfig.variant === 'light'
          ? theme.palette.text.secondary
          : theme.palette.text.secondaryDark,
      border: `1px solid ${
        instructionBarConfig.variant === 'light'
          ? theme.palette.shortcutKeyBorder
          : theme.palette.shortcutKeyBorderDark
      }`,
      borderRadius: theme.shape.borderRadius
    }
  }))(Box)

  const PaperWrapper = withStyles((theme) => ({
    root: {
      display: 'flex',
      padding: theme.spacing(1),
      width: '100%',
      color:
        instructionBarConfig.variant === 'light'
          ? theme.palette.text.secondary
          : theme.palette.text.secondaryDark,
      backgroundColor:
        instructionBarConfig.variant === 'light'
          ? theme.palette.background.paper
          : theme.palette.primary.dark
    }
  }))(Paper)

  const CloseButton = withStyles((theme) => ({
    root: {
      color:
        instructionBarConfig.variant === 'light'
          ? theme.palette.text.secondary
          : theme.palette.text.secondaryDark
    }
  }))(IconButton)

  return (
    <PaperWrapper {...instructionBarConfig} square>
      <Box flexGrow={1} paddingTop={0.5}>
        <Typography variant='caption' component='p' align='center'>
          {instructionBarConfig.instructions.map((item, iIndx) => (
            <Box key={iIndx} display='inline-block' marginRight={3} marginBottom={2}>
              {item.shortcuts.map((shortcut, sIndx) => (
                <KeyWrapper key={sIndx}>{shortcut}</KeyWrapper>
              ))}
              {`- ${item.instruction}`}
            </Box>
          ))}
        </Typography>
      </Box>
      <Box>
        <CloseButton
          aria-label='close instructions'
          size='small'
          onClick={instructionBarConfig.onCloseClick}
        >
          <CloseIcon fontSize='small' />
        </CloseButton>
      </Box>
    </PaperWrapper>
  )
}

export default InstructionBar
